import { useMutation, useQuery } from '@tanstack/react-query';

import { channelService, WooCommercePayload } from '../services/channel';

export const channelKeys = {
  all: (userId: string | number) => ['channels', userId] as const,
};


export const useChannel = () => {
  const woocommerceMutation = useMutation({
    mutationFn: (payload: WooCommercePayload) =>
      channelService.integrateWooCommerce(payload),
  });

  return {
    integrateWooCommerce: woocommerceMutation.mutate,
    integrateWooCommerceAsync: woocommerceMutation.mutateAsync,
    isIntegrating: woocommerceMutation.isPending,
    error: woocommerceMutation.error,
  };
};

export const useAllChannels = (userId: string | number) => {
  return useQuery({
    queryKey: channelKeys.all(userId),
    queryFn: () => channelService.getAllChannels(userId),
    enabled: !!userId,
  });
};
